import React, {useEffect, useMemo, useState} from 'react'
import {useEditorStageSides} from '../../../hooks/useEditorStageSides'
import {useSelectedVariantContext} from '../context/SelectedVariantContext'
import {actionInitAppliedVariants, actionSaveTemplate, actionToggleRemoveBackgroundMode} from '../context/SelectedVariantContext/action'
import EditorWrapper from './EditorWrapper'
import MockupAllAreas from './MockupAllAreas'
import MockupEditorToolbar from './MockupEditorToolbar'
import MockupStage from './MockupStage'
import {useEditorSides} from '../../../hooks/useEditorSides'
import MockupSafeZone from './MockupSafeZone'
import SwitchBetweenSidesWithHelper from './SwitchBetweenSidesWithHelper'
import {CropImage} from './CropImage'
import MockupSaveTemplate from './MockupSaveTemplate'
import DpiAlert from './DpiAlert'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner} from 'reactstrap'

const MockupEditor = () => {
    const {
        state: {editorWrapper, selectedAttribute, isAdmin, cropMode, selectedLayer, removeBackgroundMode, clientRect, cropLocal, modalSaveTemplate},
        dispatch,
    } = useSelectedVariantContext()

    const dpi = selectedLayer?.dpi
    const invalidDpi = dpi < selectedLayer?.bgDpi

    const [removeBackgroundLayer, setRemoveBackgroundLayer] = useState(null)
    const [isOpenRemoveBackground, setIsOpenRemoveBackground] = useState(false)
    const [firstInit, setFirstInit] = useState(false)
    const toggle = () => dispatch(actionSaveTemplate(!modalSaveTemplate))

    const {isOptionalSide, selectedSide} = useEditorSides()

    useEffect(() => {
        if (editorWrapper.width && editorWrapper.height) {
            if (!firstInit) {
                dispatch(actionInitAppliedVariants())
                setFirstInit(true)
            }
        }
    }, [dispatch, editorWrapper.width, editorWrapper.height, firstInit])

    const stageSides = useEditorStageSides()

    const isShowSafeZone = isAdmin && selectedSide === 'Safezone'

    const openRemoveBackgroundModal = (layer) => {
        if (!layer) return
        dispatch(actionToggleRemoveBackgroundMode(true))
        setRemoveBackgroundLayer(layer)
        setIsOpenRemoveBackground(true)
    }

    const closeRemoveBackgroundModal = () => {
        setIsOpenRemoveBackground(false)
        dispatch(actionToggleRemoveBackgroundMode(false))
    }
    const openSaveAsTemplate = () => {
        dispatch(actionSaveTemplate(true))
    }

    return (
        <EditorWrapper
            id="MockupEditor"
            classes={`MockupEditor`}
            isOpenRemoveBackground={isOpenRemoveBackground}
            toggle={closeRemoveBackgroundModal}
            removeBackgroundImageSrc={removeBackgroundLayer?.src}
            removeBackgroundMode={removeBackgroundMode}
        >
            {selectedSide === 'All' && <MockupAllAreas activeSide={selectedSide} classes={`MockupAllAreas`} />}
            {isShowSafeZone && <MockupSafeZone activeSide={selectedSide} classes={`MockupAllAreas`} />}
            {/* <div className={isOptionalSide ? 'd-none' : 'd-block'}> */}
            <SwitchBetweenSidesWithHelper />
            {stageSides.map((data, index) => {
                return data?.map((stage, index) => (
                    <MockupStage
                        key={index}
                        stage={stage}
                        isOptionalSide={isOptionalSide}
                        isActive={selectedSide === stage.side && stage.attributeIds.includes(selectedAttribute?._id)}
                        cropMode={cropMode}
                    />
                ))
            })}
            <MockupEditorToolbar
                openSaveAsTemplate={openSaveAsTemplate}
                openRemoveBackgroundModal={openRemoveBackgroundModal}
            />
            {cropMode && <CropImage selectedLayer={selectedLayer} dispatch={dispatch} clientRect={clientRect} cropLocal={cropLocal}/>}
            {modalSaveTemplate && <MockupSaveTemplate modal={modalSaveTemplate} toggle={toggle} />}

            {/*Dpi alert*/}
            <div className={'DpiAlertContainer'}>
                <DpiAlert dispatch={dispatch} selectedLayer={selectedLayer} />
            </div>
        </EditorWrapper>
    )
}

export default MockupEditor

